import SubTopicScreen from './screen';
import { connect } from 'react-redux';
import {
  getListOfSubTopics,
  getQuestionByTopicId,
} from '../../../../redux/actions/index';

const mapStateToProps = (state) => {
  return {
    state,
    loading: state.LoadingReducer.isLoading,
    userId: state.CommonReducer.userId,
    purchaseStatus: state.CommonReducer.purchaseStatus,
    sessionToken: state.CommonReducer.sessionToken,
    isNetConnected: state.LoginReducer.isNetConnected,

    showTopicList: state.QuestionReducer.showTopicList,

    subtopicList: state.QuestionReducer.subtopicList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListOfSubTopics: (subTopicRequestBody, success, errorSnackbar) =>
      dispatch(getListOfSubTopics(subTopicRequestBody, success, errorSnackbar)),

    getQuestionByTopicId: (questionBody, questionId, errorSnackbar) =>
      dispatch(getQuestionByTopicId(questionBody, questionId, errorSnackbar)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubTopicScreen);
